export default __webpack_public_path__ + "static/media/factory__28.82ea45bb.jpg";